/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as resolveTargets } from './aria-labelledby-6-ki3akM.js';
import { b as watchValidator, L as Log } from './common-D-vggmh2.js';

const validateAriaLabelledby = (component, host, internals, value) => {
    watchValidator(component, '_ariaLabelledby', (value) => typeof value === 'string' || typeof value === 'undefined', new Set(['string']), value);
    const elements = resolveTargets(host, value);
    if (internals) {
        try {
            internals.ariaLabelledByElements = elements;
        }
        catch (_a) {
        }
        Log.debug(['WebComponent internals', internals]);
    }
    return elements;
};

export { validateAriaLabelledby as v };
//# sourceMappingURL=aria-labelledby-D6AMAZtK.js.map

//# sourceMappingURL=aria-labelledby-D6AMAZtK.js.map